module.exports = __webpack_public_path__ + "static/media/image.ef335628.png";